import type { TokenSymbol } from "@/domains/core"
import { ScaleCard400 } from "@/domains/design/components/scale-card-400"

import { BodySM } from "../design/components/body-sm"
import { BodyXs } from "../design/components/body-xs"

export const StrictApprovalWarning = ({
  token0,
  token1,
}: {
  token0: TokenSymbol | undefined
  token1: TokenSymbol | undefined
}) => {
  return (
    <ScaleCard400 className={"w-fit min-w-[320px] space-y-4 px-4 py-4"}>
      <BodySM className="text-t100">Strict approval mode detected</BodySM>

      <BodyXs className="text-t200">
        Adding LP Positions with strict mode can cause entries to fail as trades can occur on the pool during your
        approval and entry transactions which give the pool a different {token0?.symbol} and {token1?.symbol} balance
        than expected. it is advised to use infinite approvals on these contracts and revoke them afterwards if that
        makes you comfortable.
      </BodyXs>
      <BodyXs className="text-t300">
        All of our pools are immutable so this carries less risk than an upgradeable contract.
      </BodyXs>
    </ScaleCard400>
  )
}
